export default __webpack_public_path__ + "static/media/noimg.190fa575.svg";